export const commonStyle = {
  root: {
    height: "100%",
  },
  content: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    fontSize: "28px",
    padding: "5px 0px",
    fontWeight: "400",
  },
  SettlementContent: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    fontSize: "28px",
    padding: "5px 0px",
    fontWeight: "400",
  },
  hideText: {
    display: "none",
  },
  details: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
  title: {
    justifyContent: "center",
    display: "flex",
    fontSize: "20px",
  },
  secondTitle: {
    justifyContent: "center",
    display: "flex",
    fontSize: "14px",
  },
  secondSettlementTitle: {
    fontSize: "16px",
    fontWeight: "510",
    display: "flex",
    justifyContent: "center",
  },
  cardWrapper: {
    borderRadius: "0px",
  },
  cardContentWrapper: {
    paddingBottom: "16px !important",
  },
  textIconWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0px",
    justifyContent: "space-around",
  },
  secondTextIconWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "2px 0px",
    height: "24px",
    justifyContent: "space-around",
  },
  secondTextWrapper: {
    alignItems: "center",
    padding: "2px 0px",
    height: "33px",
    justifyContent: "space-around",
    display: "flex",
  },
  popOverClass: {
    borderRadius: "none",
  },
  processing: {
    marginLeft: "-13px",
    color: "#f47c21",
    fontSize: "14px",
    textAlign: "center",
  },
};
